
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useIsMobile } from "./hooks/use-mobile";
import { ThemeProvider } from "next-themes";
import WasherRepair from "./pages/services/WasherRepair";
import DryerRepair from "./pages/services/DryerRepair";
import DishwasherRepair from "./pages/services/DishwasherRepair";
import StoveRepair from "./pages/services/StoveRepair";
import RefrigeratorRepair from "./pages/services/RefrigeratorRepair";
import OvenRepair from "./pages/services/OvenRepair";
import FloatingButton from "./components/FloatingButton";
import Advantages from "./pages/Advantages";
import TestimonialsPage from "./pages/Testimonials";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 60, // 1 hour
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const isMobile = useIsMobile();
  console.log("Is mobile view:", isMobile);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-[#222222] flex flex-col">
              <Navbar />
              <div className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/advantages" element={<Advantages />} />
                  <Route path="/testimonials" element={<TestimonialsPage />} />
                  <Route path="/services/washer-repair" element={<WasherRepair />} />
                  <Route path="/services/dryer-repair" element={<DryerRepair />} />
                  <Route path="/services/dishwasher-repair" element={<DishwasherRepair />} />
                  <Route path="/services/stove-repair" element={<StoveRepair />} />
                  <Route path="/services/refrigerator-repair" element={<RefrigeratorRepair />} />
                  <Route path="/services/oven-repair" element={<OvenRepair />} />
                </Routes>
              </div>
              <Footer />
              <FloatingButton />
              <Toaster />
              <Sonner />
            </div>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
